<template>
    <v-card>
        <v-row no-gutters>
            <v-col
                cols="12"
                class="d-flex align-center justify-space-between"
                :class="{
                    'py-4 px-6': $vuetify.breakpoint.smAndUp,
                    'py-4 px-3': $vuetify.breakpoint.xsOnly,
                }"
            >
                <h2 v-if="mode === 'create'">Create Suggestion Group</h2>
                <h2 v-else>Edit Suggestion Group</h2>
                <v-btn icon :large="$vuetify.breakpoint.smAndUp" @click="hideModal()">
                    <v-icon :large="$vuetify.breakpoint.smAndUp">close</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" class="pa-0 ma-0">
                <v-divider class="mx-0"></v-divider>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col
                cols="12"
                :class="{
                    'px-6 py-8': $vuetify.breakpoint.smAndUp,
                    'py-12 px-3': $vuetify.breakpoint.xsOnly,
                }"
            >
                <v-form ref="editSuggestionGroupForm" :lazy-validation="true">
                    <v-text-field v-model="suggestionGroup.name" clearable color="secondary" label="Name" required></v-text-field>
                    <v-text-field v-model="suggestionGroup.businesses" clearable color="secondary" label="Businesses" required></v-text-field>
                    <v-select
                        v-model="suggestionGroup.city"
                        :items="[
                            { label: 'Athens', value: 'athens' },
                            { label: 'SKG', value: 'skg' },
                        ]"
                        label="City"
                        item-text="label"
                        item-value="value"
                        color="secondary"
                    ></v-select>
                    <v-btn block x-large color="secondary" @click="validateEditSuggestionGroupForm()" class="mt-6">
                        Submit
                    </v-btn>
                </v-form>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import * as R from 'ramda';
import { mapMutations } from 'vuex';
import { ADD_SUGGESTION_GROUP_MUTATION, EDIT_SUGGESTION_GROUP_MUTATION } from '@/store/modules/suggestions/types';
import { SET_SNACKBAR_STATUS } from '@/store/mutation-types';
import { SuggestionsApi } from '@/api';

export default {
    name: 'EditSuggestionGroup',
    props: {
        suggestionGroup: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            default: 'create',
        },
    },
    data: () => ({}),
    methods: {
        ...mapMutations('Suggestions', {
            addSuggestionGroupMutation: ADD_SUGGESTION_GROUP_MUTATION,
            editSuggestionGroupMutation: EDIT_SUGGESTION_GROUP_MUTATION,
        }),
        validateEditSuggestionGroupForm() {
            if (this.$refs.editSuggestionGroupForm.validate()) {
                if (this.mode === 'create') {
                    this.createSuggestionGroup();
                } else {
                    this.updateSuggestionGroup();
                }
            }
        },
        async createSuggestionGroup() {
            const clonedSuggestionGroup = R.clone(this.suggestionGroup);
            clonedSuggestionGroup.businesses = clonedSuggestionGroup.businesses.split(',');
            const { data } = await SuggestionsApi.createSuggestionGroup(clonedSuggestionGroup);
            this.addSuggestionGroupMutation(data);
            this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Suggestion group created successfully', color: 'success' });
            this.hideModal();
        },
        async updateSuggestionGroup() {
            const clonedSuggestionGroup = R.clone(this.suggestionGroup);
            clonedSuggestionGroup.businesses = clonedSuggestionGroup.businesses.split(',');
            const { data } = await SuggestionsApi.updateSuggestionGroup(this.suggestionGroup['id'], clonedSuggestionGroup);
            this.editSuggestionGroupMutation(data);
            this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Suggestion group updated successfully', color: 'success' });
            this.hideModal();
        },
        hideModal() {
            this.$emit('hide');
        },
    },
};
</script>
